@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.root {
    overflow: hidden;
    padding: 100px 0;
    position: relative;
}

.backgroundImage {
    left: 0;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        left: unset;
        right: 0;
        width: auto;
    }
}

.wrapper {
    position: relative;
    z-index: 10;

    & > div {
        /* Directly target the last section element */
        & > section:last-of-type {
            /* Then target an immediate image */
            & > img {
                /* and adjust the positioning */
                bottom: -100px;
                position: relative;
            }
        }
    }
}

.textLight {
    --text-color: var(--color-white);

    & * {
        color: var(--color-white) !important;
    }
}

.textDark {
    --text-color: var(--color-black);

    & *:not(a) {
        color: var(--color-black) !important;
        text-shadow: none !important;
    }
}
